import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss']
})
export class CheckboxComponent {

  @Input() label: string;
  @Input() labelVisible = true;
  @Input() id: string;
  @Input() isChecked: boolean;
  @Input() checkboxVisible = true;
  @Input() size: string;
  @Input() textForm = 'capitalize';
  @Input() side: string;
  @Input() bold = true;
  @Output() checked = new EventEmitter<boolean>();

}
